export default class PortfolioItemModel {
    constructor(name, description, image, iosUrl, androidUrl, websiteUrl) {
        this.name = name;
        this.description = description;
        this.image = image;
        this.iosUrl = iosUrl;
        this.androidUrl = androidUrl;
        this.websiteUrl = websiteUrl;
    }
}